import React from 'react';
import styled from '@emotion/styled';

const NavbarHamburger = ({ isMobileNavOpen }) => {
  return (
    <IconWrapper
      className={isMobileNavOpen ? 'change' : ' '}
      data-cy="menuIcon"
    >
      <div className="bar1"></div>
      <div className="bar2"></div>
      <div className="bar3"></div>
    </IconWrapper>
  );
};

export default NavbarHamburger;

const IconWrapper = styled.div`
  display: inline-block;
  cursor: pointer;
  position: relative;
  padding: 10px 8px;

  .bar1,
  .bar2,
  .bar3 {
    display: block;
    position: absolute;
    width: 16.5px;
    height: 2px;
    background-color: white;
    transition: 0.4s;
  }
  .bar1 {
    top: 10px;
  }
  .bar2 {
    top: 15.5px;
  }
  .bar3 {
    top: 21px;
  }

  &.change .bar1 {
    -moz-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 16.5px;
  }

  &.change .bar2 {
    opacity: 0;
  }

  &.change .bar3 {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    transform: rotate(45deg);
    top: 16.5px;
  }
`;
